import { useEffect, useRef } from 'react';
import { toast } from '@/components/ui';
import { pgRecoverErrorMessage, usePgRecoverMutation } from '../hooks/usePgRecoverMutation';

/**
 * QA-599 — [결제완료 (PG 확인)] 확인 후에만 마운트해 한 번 실행한다(주문 상세는 조회 훅 없이도 그려져야 해서 — 열 때만 훅).
 */
export const PgRecoverRunner = ({ orderId, onDone }: { orderId: string; onDone: () => void }) => {
  const pgRecover = usePgRecoverMutation(orderId);
  const started = useRef(false);
  useEffect(() => {
    if (started.current) return;
    started.current = true;
    pgRecover.mutate(undefined, {
      onSuccess: () => toast.success('토스 결제 완료를 확인했습니다. 잠시 후 결제완료로 바뀝니다.'),
      onError: (e) => toast.error(pgRecoverErrorMessage(e)),
      onSettled: onDone,
    });
  }, [pgRecover, onDone]);
  return null;
};
